import { isValidElement } from "react";

const INTERACTIVE_ELEMENTS = ["button", "a", "input", "textarea", "select"];

export function isNonInteractiveElement(element: React.ReactElement) {
  if (!isValidElement(element)) return false;
  const type = element.type as string;
  return typeof type === "string" && !INTERACTIVE_ELEMENTS.includes(type);
}
